/**
 * 叫号模块 请求 api
 */
// 引入工具函数
import req from '@/utils/request';

// 新增议价绑定
export const discountBind = (params) => {
  return req.post('/discount/bind', params);
}
export const discountGet = (params) => {
  return req.get('/discount/bind/get', params);
}
export const discountUnbind = (params) => {
  return req.delete('/discount/unbind', params);
}
